const DemoDataGenerator = {
    init() {
        window.activateCommercialDemo = this.activateCommercialDemo.bind(this);
        console.log('🧪 DemoDataGenerator initialized.');
    },

    activateCommercialDemo() {
        if (!confirm("⚠️ ADVERTENCIA: Esto borrará todos los datos actuales y generará una clase simulada. ¿Continuar?")) {
            return;
        }

        console.log("🚀 Iniciando Modo Demo Comercial...");

        // 1. Limpiar base de datos
        if (window.UserManager) {
            // Get all current users to clean their local storage keys
            window.UserManager.users.forEach(u => {
                const prefix = `${u.id}_`;
                Object.keys(localStorage).forEach(key => {
                    if (key.startsWith(prefix)) localStorage.removeItem(key);
                });
            });
            window.UserManager.users = [];
            window.UserManager.saveUsersList();
        }

        // 2. Crear alumnos simulados
        const mockNames = ["Hugo", "Martina", "Leo", "Sofía", "Lucas", "Lucía", "Mateo", "Valeria", "Daniel", "Alba", "Álvaro", "Julia", "Enrique", "Paula", "Mario"];
        const avatars = (window.LoginScreen && window.LoginScreen.avatarSeeds) 
            ? window.LoginScreen.avatarSeeds 
            : ['🤖', '👾', '🚀', '🐱', '🐶', '👻', '🦄', '🏃', '👧', '👦'];
        
        const group = "1A";

        mockNames.forEach((name, idx) => {
            const avatar = avatars[idx % avatars.length];
            const user = window.UserManager.createUser(name, avatar);
            window.UserManager.updateUserGroup(user.id, group);

            // Simular Progreso
            const problemsCount = Math.floor(Math.random() * 20) + 5; // 5 to 25 problems
            const correctSumas = Math.floor(Math.random() * problemsCount * 0.5) + 2;
            const attemptedSumas = correctSumas + Math.floor(Math.random() * 4);
            const correctRestas = Math.floor(Math.random() * problemsCount * 0.4) + 1;
            const attemptedRestas = correctRestas + Math.floor(Math.random() * 5);

            const sessionHistory = [];
            for (let i = 0; i < 10; i++) {
                sessionHistory.push({
                    date: new Date(Date.now() - (10 - i) * 86400000).toISOString(),
                    type: Math.random() > 0.5 ? 'suma' : 'resta',
                    duration: Math.floor(Math.random() * 40) + 15, // 15s to 55s
                    score: Math.floor(Math.random() * 100) + 50
                });
            }

            const mockProgress = {
                xp: problemsCount * 120,
                level: Math.floor(problemsCount / 5) + 1,
                problemsCompleted: problemsCount,
                stats: {
                    suma: { correct: correctSumas, attempted: attemptedSumas },
                    resta: { correct: correctRestas, attempted: attemptedRestas }
                },
                sessionHistory: sessionHistory,
                badges: ["first_problem", "fast_solver"],
                lastPlayed: new Date().toISOString()
            };

            // Save progress
            window.UserManager.saveUserData(user.id, 'math_detectives_progress', mockProgress);
        });

        alert("✅ Modo Demo Activado: Se ha generado una clase '1A' con 15 alumnos, notas y gráficas.");
        
        // Refrescar panel si está abierto
        const dashboard = document.getElementById('parentsDashboardScreen');
        if (dashboard && !dashboard.classList.contains('hidden')) {
            if (window.ParentsDashboard) window.ParentsDashboard.renderDashboard('teacher');
        } else {
            const login = document.getElementById('loginScreen');
            if (login && !login.classList.contains('hidden') && window.LoginScreen) {
                window.LoginScreen.renderProfiles();
            }
        }
    }
};

DemoDataGenerator.init();
export default DemoDataGenerator;
